import { createFileRoute, Outlet } from '@tanstack/react-router';
import { IdCard } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/attestations')({
    staticData: {
        breadcrumb: {
            title: 'Attestations',
            inactive: true,
        },
        roles: ['attestations_user', 'org_admin'],
        modules: ['attestations'],
        ui: {
            icon: IdCard,
        },
    },
    component: Outlet,
});
